module.exports = __webpack_public_path__ + "img/roundClose.d1dde780.svg";